<template>

        <rkm-form
            ref="Form"
        >
            <rkm-tabs
                v-model="tabIndex"
            >
                <rkm-tab
                    title="Exame"
                    class="remove-padding-top"
                >
                    <ListExame :data="data" :itemsExames="itemsExames" ref="TabCotaExame" />
                </rkm-tab>

                <rkm-tab
                    title="Laboratório"
                >
                    <ListLaboratorio
                        :data="data"
                        :itemsLaboratorio="itemsLaboratorio"
                        :itemsCotasTransferencia="itemsCotasTransferencia"
                        ref="TabCotaLaboratorio"
                    />
                </rkm-tab>

                <rkm-tab
                    title="Unidade solicitante"
                >
                    <ListUnidade
                        :data="data"
                        :itemsUnidadeSolicitante="itemsUnidadeSolicitante"
                        :itemsCotasTransferenciaUnidade="itemsCotasTransferenciaUnidade"
                        ref="TabCotaUnidadeSolicitante"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
</template>

<script>
// Components.
import ListUnidade from './unidade/unidade-solicitante/List'
import ListLaboratorio from './unidade/laboratorio/List'
import ListExame from './exame/List'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

// Mixins.
import { formats, data } from '@/mixins'

export default {
    components: { ListUnidade, ListLaboratorio, ListExame},
    props: {
        data: { type: Object, required: true },
    },
    mixins: [ formats, data ],
    data: () => ({
        model: {
            laboratorio: [],
            imagem: [],
        },
        form: {},
        tabIndex: 0,
        tabRefs: [],
        itemsLaboratorio: [],
        itemsUnidadeSolicitante: [],
        itemsExames: [],
        itemsCotasTransferencia: [],
        itemsCotasTransferenciaUnidade: [],
        loaded: false,
        enums: {
            tipoUnidade
        },
    }),
    mounted() {

        this.tabRefs = [
            this.$refs.TabCotaUnidadeSolicitante,
            this.$refs.TabCotaLaboratorio,
            this.$refs.TabCotaExame,
        ]
    },
    watch: {
        'data.model.cotasLaboratorio' (unidades) {

            this.itemsLaboratorio = unidades.filter(field => field.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO)
        },
        'data.model.cotasExamePeriodo' (cotasExamePeriodo) {
            this.itemsExames = cotasExamePeriodo.map(cotaExamePeriodo => {

                return {
                    id: cotaExamePeriodo.id,
                    nome: cotaExamePeriodo.exameNome,
                    inicio: cotaExamePeriodo.periodo.start,
                    fim: cotaExamePeriodo.periodo.end,
                    tipo: cotaExamePeriodo.cotaNome,
                    tipoId: cotaExamePeriodo.cotaTipoId,
                    utilizada: '0',
                    unidade: cotaExamePeriodo.unidade,
                    unidadeId: cotaExamePeriodo.unidadeId,
                    infraestrutura: cotaExamePeriodo.infraestrutura,
                    infraestruturaId: cotaExamePeriodo.infraestruturaId,
                    alterado: cotaExamePeriodo.alterado,
                    exames: cotaExamePeriodo.exames,
                }
            })
        },
        'data.model.cotasUnidadeSolicitante' (unidades) {

            this.itemsUnidadeSolicitante = unidades.filter(field => field.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE)
        },
        'data.model.cotasTransferencia' (unidades) {

            this.itemsCotasTransferencia = unidades.filter(field => field.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO)
            this.itemsCotasTransferenciaUnidade = unidades.filter(field => field.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE)
        }
    }
}
</script>

<style scoped>
.tabs {
    border: 0px solid #dee2e6!important;
    border-radius: 0.25rem;
}
</style>